/**
 * Formulaire de login
 */

import { useState, FormEvent } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ProfilEnum } from '@/shared/types/user';

const SOIGNANT_PROFILS: string[] = [
  ProfilEnum.IDE,
  ProfilEnum.MEDECIN,
  ProfilEnum.AS,
  ProfilEnum.SECRETAIRE,
];

export function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // login() retourne le User (BUG-4 corrigé — état React non disponible immédiatement)
      const loggedUser = await login(email, password);
      if (SOIGNANT_PROFILS.includes(loggedUser.profil)) {
        navigate('/vocal');
      } else {
        navigate('/home');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur de connexion');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page-bg min-vh-100 d-flex align-items-center justify-content-center px-4">
      <div className="card card-premium bounce-in" style={{ maxWidth: '420px', width: '100%' }}>
        <div className="card-body p-5">
          {/* Logo & Header */}
          <div className="text-center mb-4">
            <div className="mb-3">
              <i className="bi bi-heart-pulse-fill text-primary" style={{ fontSize: '3.5rem' }}></i>
            </div>
            <h1 className="text-gradient fw-bold mb-2" style={{ fontSize: '2rem' }}>
              Horaliia
            </h1>
            <p className="text-muted mb-0">
              <i className="bi bi-mic me-1"></i>
              Assistant de documentation clinique
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-danger d-flex align-items-center fade-in mb-4" role="alert">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                <div>{error}</div>
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="email" className="form-label fw-semibold">
                <i className="bi bi-envelope me-1"></i>
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-control form-control-lg"
                placeholder="votre.email@hopital.fr"
                autoComplete="email"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label fw-semibold">
                <i className="bi bi-lock me-1"></i>
                Mot de passe
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control form-control-lg"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn btn-primary btn-lg w-100 shadow-glow mb-3"
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Connexion...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Se connecter
                </>
              )}
            </button>
          </form>

        </div>

      </div>
    </div>
  );
}
